import { liveQueryKeys } from '@module/queries/live/liveQueryKeys';
import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import {
  isPersonalUpdateUserInfoMessage,
  type PersonalUpdateUserInfoMessage,
} from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalUpdateUserInfoHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalUpdateUserInfoMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalUpdateUserInfoMessage(payload);
  }

  handle(payload: PersonalUpdateUserInfoMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.queryClient.invalidateQueries({ queryKey: liveQueryKeys.fetchMemberinfo._def, exact: false });
  }
}
